import React from 'react';
import styled from '@emotion/styled';
import { mediaQuery } from '@styles/index';

interface FlexRowProps {
  className?: string;
  children: React.ReactNode;
}

const StyledFlexRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -8px;
  ${mediaQuery.uptoTablet} {
    margin: 0;
  }
`;

const FlexRow: React.FC<FlexRowProps> = ({ className, children }) => {
  return <StyledFlexRow className={className}>{children}</StyledFlexRow>;
};

FlexRow.displayName = 'FlexRow';

FlexRow.defaultProps = { className: '' };

export default FlexRow;
